export default __webpack_public_path__ + "static/media/vera.0ec5fddd.gif";